/* global __CLIENT__ */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//     faCompactDisc,
//     faUser,
// } from '@fortawesome/free-solid-svg-icons';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
import { fetchLastPlayedSongsIfNeeded } from '../../aovivo/actions/LastPlayedSongsAction';

const UPDATE_INTERVAL = 10000;

class NowPlayingComponent extends Component {
    constructor() {
        super();

        if (__CLIENT__) {
            // Set the name of the hidden property and the change event for visibility
            if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
                this.hiddenProperty = 'hidden';

                this.visibilityChangeEvent = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this.hiddenProperty = 'msHidden';

                this.visibilityChangeEvent = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this.hiddenProperty = 'webkitHidden';

                this.visibilityChangeEvent = 'webkitvisibilitychange';
            }
        }
    }

    componentDidMount() {
        // delay the first meta data fetch slightly so the player can establisch itself
        setTimeout(() => { this.props.fetchNowPlayingIfNeeded(); }, 1500);

        this.interval = setInterval(() => {
            this.props.fetchNowPlayingIfNeeded();
        }, UPDATE_INTERVAL);

        document.addEventListener(this.visibilityChangeEvent, this._handleVisibilityChange);
    }

    componentWillUnmount() {
        clearInterval(this.interval);

        document.removeEventListener(this.visibilityChangeEvent, this._handleVisibilityChange);
    }

    _handleVisibilityChange = () => {
        if (!document[this.hiddenProperty]) {
            // We come back from the page, fetch the metadada if needed.

            fetchLastPlayedSongsIfNeeded();
        }
    };

    render() {
        const album = this.props.album || 'Antena 1';
        const artist = this.props.artist || 'Antena 1';
        const artistSlug = this.props.artistSlug;
        const song = this.props.song || 'A Rádio Online mais ouvida do Brasil';
        const musicSlug = this.props.musicSlug;
        const year = this.props.year;
        /* itunes = this.props.itunes && !this.props.isExtraSmall ? (
                <Itunes href={`${this.props.itunes}&at=11lStv&ct=player&app=itunes`}/>
            ) : null, */
        const coverImage = this.props.cover ?
            this.props.cover.replace('1000x1000', '150x150') :
            'https://a1media.antena1.com.br/image/album/150x150/defaultAlbum.jpg';
        const longArtistName = artist.length > 16;
        const longSongName = song.length > 20;


        if (this.props.isLoading) {
            return (
                <div className="NowPlaying">
                    <span className="Connect">Conectando</span>
                </div>
            );
        }

        const isAoVivoPage = this.props.history.location.pathname === '/ouvir-radio-online';


        return (
            <div className="NowPlaying md:ml-4">
                {!isAoVivoPage ?
                    <Button className="albumButton" to="/ouvir-radio-online" title="Ouvir rádio online">
                        <figure title={album}>
                            {this.props.locked && <div className="" />}
                            <img alt={`Capa do Álbum: ${album}`} src={coverImage} />
                        </figure>
                    </Button>
                    :
                    <button
                        className="albumCover"
                        type="button"
                        onClick={() => { animateScrollTo(0, { speed: 700 }); }}
                    >
                        <figure title={album}>
                            {this.props.locked && <div className="" />}
                            <img alt={`Capa do Álbum: ${album}`} src={coverImage} />
                        </figure>
                    </button>}
                <div className="Meta">
                    <div className={`Song${longSongName ? ' longSongName' : ''}`}>
                        {
                            musicSlug && artistSlug ?
                                <Button className="nowPlayingLink" to={`/musicas/${musicSlug}+${artistSlug}`} title="Página da música">
                                    {song}
                                    {/* <FontAwesomeIcon icon={faCompactDisc} className="linkIcon" /> */}
                                </Button>
                                :
                                song
                        }
                    </div>
                    <div className={`Artist${longArtistName ? ' longArtistName' : ''}`}>
                        {
                            artistSlug ?
                                <Button className="nowPlayingLink" to={`/artistas/${artistSlug}`} title="Página do artista">
                                    {artist}
                                    {/* <FontAwesomeIcon icon={faUser} className="linkIcon bottomCorrected" /> */}
                                </Button>
                                :
                                artist
                        }
                    </div>
                    {year &&
                        <div className="Year">
                            {`(${year})`}
                        </div>}
                    {/* itunes */}
                </div>
            </div>
        );
    }
}

NowPlayingComponent.propTypes = exact({
    album: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    artist: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    artistSlug: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    musicSlug: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    year: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.bool,
    ]),
    song: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    cover: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    locked: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool,
    history: PropTypes.object,
    fetchNowPlayingIfNeeded: PropTypes.func.isRequired,
    /* eslint-disable react/no-unused-prop-types */
    // Injected through withRouter but not used
    match: PropTypes.object,
    staticContext: PropTypes.object,
    location: PropTypes.object,
    /* eslint-enable react/no-unused-prop-types */
});

export default NowPlayingComponent;
